import { User } from '../screens/user/Users';

export interface RedpackTemplate {
  id: number;
  name: string;
  description: string;
  minAmount: number;
  maxAmount: number;
  receiveLimit: number;
  totalAmountLimit: number;
  redpacks: Redpack[];
}

export interface GRedpackTemplate extends RedpackTemplate {
  redpacksConnection: {
    nodes: Redpack[];
    pageInfo: {
      startCursor?: number;
      endCursor?: number;
      totalCount: number;
    };
  };
}

export interface Redpack {
  id: number;
  sendStatus: number;
  createdAt: Date;
  amount: number;
  user: User;
}

export enum RedpackSendStatus {
  UNKNOWN, // 未知
  SUCCESS, // 成功
  FAILED, // 失败
  SENDING, // 发放中
  SENT, // 已发放待领取
  RECEIVED, // 已领取
  REFUND_ING, // 退款中
  REFUND, // 已退款
  RESENT, // 已重发
}

export const WECHAT_REDPACK_SEND_STATUS = {
  [RedpackSendStatus.UNKNOWN]: '未知',
  [RedpackSendStatus.SUCCESS]: '成功',
  [RedpackSendStatus.FAILED]: '失败',
  [RedpackSendStatus.SENDING]: '发放中',
  [RedpackSendStatus.SENT]: '已发放待领取',
  [RedpackSendStatus.RECEIVED]: '已领取',
  [RedpackSendStatus.REFUND_ING]: '退款中',
  [RedpackSendStatus.REFUND]: '已退款',
  [RedpackSendStatus.RESENT]: '已重发',
};



// WEBPACK FOOTER //
// ./src/types/redpack.ts